/**
 * docPropSaveErrorToast: a tiny global listener that surfaces doc-property
 * save failures so they are never silent. Both surfaces (MainView panel and
 * the /docprops page) dispatch `pidly:docprop-save-error` with a message
 * string when a granular save throws; this hands it to the one notice store
 * (utils/notices.js), so it looks like every other notice.
 */
import { showNotice } from './notices';

export function initDocPropSaveErrorToast() {
  if (typeof window === 'undefined' || window.__docPropSaveErrToastInit) return;
  window.__docPropSaveErrToastInit = true;
  window.addEventListener('pidly:docprop-save-error', (e) => showNotice({
    id: 'docprop-save-error',
    kind: 'error',
    title: "Couldn't save the document property",
    detail: `${String(e?.detail || 'Please retry.')} Your edit is still shown here and will sync on the next change, or reload to be sure.`,
  }));
}
